import React from 'react'
import moment from 'moment'
import upperFirst from 'lodash/upperFirst'
import classnames from 'classnames'
import find from 'lodash/find'
import LoadingIndicator from '@/components/LoadingIndicator'
import Tooltip from '@/components/Tooltip'

export class ReportingCycleSubmission extends React.Component {
  frequencyDescription () {
    const { frequency, localize } = this.props
    return localize(`Reporting.FrequencyDescription_${frequency}`)
  }
  dayAbbreviation (date) {
    const day = moment(date).weekday()
    return this.props.localize(`Enums.WeekDayAbbr_${day}`)
  }
  handleDateClick (editedDate) {
    const { submission, disabled } = this.props
    if (submission.isActive && !disabled) {
      this.props.onDateClick(submission, editedDate)
    }
  }
  hasCollision (date) {
    const dates = ((this.props.reportingCycleCollisions || {}).dates || [])
    const d = find(dates, x => x.getTime() === date.getTime())
    return !!d
  }
  renderSubmission (dateType, submission, additionalCss = '') {
    const date = submission[dateType]
    const title = this.props.localize(`Reporting.${upperFirst(dateType)}`)
    const collisionCss = (this.hasCollision(date) ? 'c-date--need-fix' : '')
    const isActiveCss = (submission.isActive === true ? 'submission-active' : 'submission-inactive')
    return (<div className={`c-date ${additionalCss} ${collisionCss} ${isActiveCss}`} disabled={this.props.disabled} title={title} onClick={() => this.handleDateClick(dateType)}>
      <span>{this.dayAbbreviation(date)}</span>
      <span>{moment(date).format('D/M')}</span>
    </div>)
  }
  handleToggle = () => {
    const { onToggleActive, submission, disabled } = this.props
    if (!disabled) {
      onToggleActive(submission)
    }
  }
  render () {
    const { localize, submission, disabled } = this.props
    return (
      <div className='cycle-set'>
        <div className='cycle-set__label'>
          <div className='c-s-l__name'>{this.frequencyDescription()}<br /> <span>{submission.order}</span></div>

          <div id={'swicher-cycle-set-' + submission.id} disabled={submission.updating || disabled} onClick={this.handleToggle} className={classnames('c-s-l__switch switcher ', { 'switcher--on': submission.isActive }, { 'switcher--off': !submission.isActive })}>
            <Tooltip placement='bottom' target={'swicher-cycle-set-' + submission.id}>{submission.isActive ? localize('Common.On') : localize('Common.Off')}</Tooltip>
          </div>
        </div>
        <div className='c-date__wrap'>
          {submission.updating && <LoadingIndicator inline />}
          {!submission.updating && <React.Fragment>
            {this.renderSubmission('snapshotDate', submission)}
            {this.renderSubmission('dueDate', submission, 'c-date--extended')}
            {this.renderSubmission('extendedDueDate', submission, 'c-date--extended-extra')}
          </React.Fragment>}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingCycles/submissions/item.js